module.exports = __webpack_public_path__ + "static/logo-chrome-a21dbd479bd4d5513d28e419c8bb3842.png";